import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import Cookies from "js-cookie";

dayjs.extend(utc);
dayjs.extend(timezone);

const timezoneVal: string = Cookies.get("timezone") || "America/Denver";

dayjs.tz.setDefault(timezoneVal);

const timezonedDayjs = (...args: any[]) => {
  return dayjs(...args).tz();
};

const timezonedUnix = (value: number) => {
  return dayjs.unix(value).tz();
};

timezonedDayjs.unix = timezonedUnix;

export default timezonedDayjs;
